export default __webpack_public_path__ + "static/media/image 11.7ec037b7.svg";